<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-06 16:44:19
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2021-01-14 15:26:50
 * @Description: 图片组件
 * @FilePath: /hsylc2021/src/components/Image/index.vue
-->
<template>
  <div class="component-image" :class="computedClass">
    <template v-if="finishLoad">
      <img class="inner-image" :src="imgSrc" :style="imgStyle" v-if="type === TYPES.IMG" />
      <div class="inner-bg" :style="bgStyle" v-else-if="type === TYPES.BG"></div>
    </template>
    <div class="c-loader" v-else></div>
  </div>
</template>
<script>
const TYPES = {
  IMG: 'img',
  BG: 'bg'
};
/**
 * 图片懒加载组件
 * @module LazyImage
 */
export default {
  name: 'LazyImage',
  /**
   * @prop {String} className 外部class
   * @prop {String} src 图片资源
   * @prop {String} type 图片类型 img/bg 默认img
   * @prop {String} imgWidth 图片宽度 默认100%
   * @prop {String} imgHeight 图片高度 默认auto
   * @prop {String} bgSize 背景background-size 默认cover
   * @prop {String} bgRepeat 背景background-repeat 默认no-repeat
   * @prop {String} bgPosition 背景background-position 默认center center
   */
  props: {
    className: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: TYPES.IMG
    },
    imgWidth: {
      type: String,
      default: '100%'
    },
    imgHeight: {
      type: String,
      default: 'auto'
    },
    bgSize: {
      type: String,
      default: 'contain'
    },
    bgRepeat: {
      type: String,
      default: 'no-repeat'
    },
    bgPosition: {
      type: String,
      default: 'center center'
    }
  },
  /**
   * @prop {Object} computedClass 组件class
   * @prop {Object} imgStyle 图片style
   * @prop {Object} bgStyle 背景Style
   * @prop {Object} TYPES 类型
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[this.className] = true;
      return ret;
    },
    imgStyle() {
      let ret = {};
      if (this.type === TYPES.IMG) {
        ret.width = this.imgWidth;
        ret.height = this.imgHeight;
      }
      return ret;
    },
    bgStyle() {
      let ret = {};
      if (this.type === TYPES.BG) {
        ret.backgroundImage = `url(${this.imgSrc})`;
        ret.backgroundSize = this.bgSize;
        ret.backgroundPosition = this.bgPosition;
        ret.backgroundRepeat = this.bgRepeat;
      }
      return ret;
    },
    TYPES() {
      return TYPES;
    }
  },
  /**
   * @prop {Boolean} finishLoad 图片加载完成
   * @prop {String} imgSrc 实际放到容器中的地址
   */
  data: () => ({
    finishLoad: false,
    imgSrc: ''
  }),
  watch: {
    src(src) {
      this.handleOnLoad(src);
    }
  },
  /**
   * @event onLoad 图片加载完成
   */
  /**
   * @description mounted钩子
   * @function mounted
   */
  mounted: function() {
    this.handleOnLoad(this.src);
  },
  methods: {
    handleOnLoad: function(src) {
      this.imgSrc = '';
      if (src && !!src) {
        let image = new Image();
        image.src = this.src;
        image.onload = () => {
          this.imgSrc = image.src;
          this.finishLoad = true;
          this.$emit('onLoad');
        };
      }
    }
  }
};
</script>
<style lang="less" scoped>
.component-image {
  position: relative;
  .inner-bg {
    width: 100%;
    height: 100%;
  }
  .c-loader {
    margin-top: -9px;
    margin-left: -9px;
    position: absolute;
    left: 50%;
    top: 50%;
  }
}
</style>
